import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";

const empty = { name: "", email: "", phone: "", preferred_date: "", guests: "", message: "" };

export const InquiryDialog = ({ open, onOpenChange, option, eventSlug }) => {
  const [form, setForm] = useState(empty);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/inquiries", { ...form, guests: Number(form.guests) || 0, option, event_slug: eventSlug });
      toast.success("Request sent. We'll be in touch with a quote.");
      setForm(empty);
      onOpenChange(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="border-[#E5DACA] bg-white sm:max-w-lg" data-testid="inquiry-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-[#1F1B17]">Request a quote</DialogTitle>
          <DialogDescription className="text-[#6B6157]">{option}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2">
          <div className="sm:col-span-2"><Label htmlFor="iq-name">Name</Label><Input id="iq-name" required value={form.name} onChange={set("name")} data-testid="inquiry-name-input" /></div>
          <div><Label htmlFor="iq-email">Email</Label><Input id="iq-email" type="email" required value={form.email} onChange={set("email")} data-testid="inquiry-email-input" /></div>
          <div><Label htmlFor="iq-phone">Phone</Label><Input id="iq-phone" value={form.phone} onChange={set("phone")} data-testid="inquiry-phone-input" /></div>
          <div><Label htmlFor="iq-date">Preferred date</Label><Input id="iq-date" type="date" value={form.preferred_date} onChange={set("preferred_date")} data-testid="inquiry-date-input" /></div>
          <div><Label htmlFor="iq-guests">Guests</Label><Input id="iq-guests" type="number" min="1" value={form.guests} onChange={set("guests")} data-testid="inquiry-guests-input" /></div>
          <div className="sm:col-span-2"><Label htmlFor="iq-msg">Tell us about your group</Label><Textarea id="iq-msg" rows={3} value={form.message} onChange={set("message")} data-testid="inquiry-message-input" /></div>
          <button type="submit" disabled={busy} data-testid="inquiry-submit-button"
            className="rounded bg-[#141210] py-3 text-sm font-semibold uppercase tracking-widest text-[#F3DDA4] transition-colors hover:bg-[#2A2520] disabled:opacity-50 sm:col-span-2">
            {busy ? "Sending…" : "Send request"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
